import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { seasonalFeatured as orgConfig } from 'org/configs/modules.config';
import { SEASONAL_FEATURED_GET_SUCCESS, SEASONAL_FEATURED_GET_FAILURE } from '../actions/types';

/** @type {object} */
const defaultConfig = {
  defaults: {
    api: {
      params: {
      },
      options: {
        success: SEASONAL_FEATURED_GET_SUCCESS,
        failure: SEASONAL_FEATURED_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
        sectionId: 10459,
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
